import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, Music } from 'lucide-react';
import { generateMissingModulesAudio } from '@/scripts/generateSpecificModuleAudio';
import { useToast } from '@/hooks/use-toast';

export const GenerateMissingAudioButton = () => {
  const [generating, setGenerating] = useState(false);
  const { toast } = useToast();

  const handleGenerate = async () => {
    try {
      setGenerating(true);
      
      toast({
        title: "Starting Audio Generation",
        description: "Generating audio for 8 missing modules...",
      });

      const result = await generateMissingModulesAudio();
      
      toast({
        title: "Audio Generation Complete",
        description: `✅ ${result.successful.length} successful, ❌ ${result.failed.length} failed`,
      });
      
      // Reload stats after generation
      window.location.reload();
      
    } catch (error) {
      console.error('Failed to generate audio:', error);
      toast({
        title: "Generation Failed",
        description: "Failed to generate audio. Check console for details.",
        variant: "destructive",
      });
    } finally {
      setGenerating(false);
    }
  };

  return (
    <Button
      onClick={handleGenerate}
      disabled={generating}
      className="gap-2"
      variant="default"
      size="lg"
    >
      {generating ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          Generating...
        </>
      ) : (
        <>
          <Music className="h-4 w-4" />
          Generate 8 Missing Modules Audio
        </>
      )}
    </Button>
  );
};
